import { render, staticRenderFns } from "./MultipleCheckbox.vue?vue&type=template&id=61631d99&scoped=true&"
import script from "./MultipleCheckbox.vue?vue&type=script&lang=js&"
export * from "./MultipleCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./MultipleCheckbox.vue?vue&type=style&index=0&id=61631d99&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61631d99",
  null
  
)

export default component.exports